<template>
  <div class="setting-content--section">
    <CarDetailsModal v-if="showCarModal" @close-modal="closeCarsModal" :carDetails="modalCarData" @carCreated="onCarCreated" @carUpdated="onCarUpdated" />

    <GekkoButton
      @click="canAddCar()"
      :text="$gettext('Add a new car')"
      icon="fa-solid fa-plus"
      class="float-right mb-3"
    />

    <div class="setting-table--wrap">
      <b-table
        id="cars-table"
        responsive
        :class="'gk-table gk-table--responsive gk-table--headed light-bg-head gk-table--striped gk-table--hover'"
        :items="tableItems"
        :fields="tableFields"
        :thead-class="tableHeaderClass"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :key="tableKey"
        @row-clicked="rowClicked"
        :tbody-transition-props="transProps"
        primary-key="id"
      >
        <template #cell(type_of_car)="data">
          <span v-if="data.item.company_profile" v-translate>Company car</span>
          <span v-if="!data.item.company_profile" v-translate>Private car</span>
        </template>
        <template #cell(used_from)="data">
          <span>{{data.item.used_from | formatDate}}</span>
        </template>
        <template #cell(used_until)="data">
          <span>{{data.item.used_until | formatDate}}</span>
        </template>
        <template #cell(archive_clickable)="data">
          <div @click.stop class="h-100 d-flex align-items-center justify-content-center">
            <CarArchive class="float-left mr-1" :data_object="data.item" @stop="rowClicked"></CarArchive>
          </div>
        </template>
        <template #cell(edit_clickable)>
          <span class="edit-button">edit</span>
        </template>
      </b-table>
    </div>


    <p v-show="!tableItems.length" class="text-warning text-center" v-translate>You have no cars. Create a new car.</p>
  </div>
</template>

<script>
import CarsService from "@/store/services/cars.service";
import CarDetailsModal from "@/components/trips/CarDetailsModal";
import settingsPageSetup from "@/mixins/settingsPageSetup";
import CarArchive from "@/components/trips/CarArchive";
import GekkoButton from "@/components/GekkoButton";

export default {
  name: "Cars",
  components: { CarArchive, CarDetailsModal, GekkoButton},
  mixins: [settingsPageSetup],
  data() {
    return {
      pageSettings: {
          title: this.$gettext("Your cars"),
          showCompanyPicker: true
      },
      transProps: {
        name: 'flip-list'
      },
      modalCarData: this.getDefaultCarData(),
      showCarModal: false,
      tableKey: 0,
      sortBy: "used_from",
      sortDesc: true,
      tableFields: [
        { key: "type_of_car", label: this.$gettext("TYPE OF CAR") },
        { key: "plate_number", label: this.$gettext("PLATE NUMBER"), tdClass: 'text-nowrap' },
        { key: "brand", label: this.$gettext("BRAND") },
        { key: "model", label: this.$gettext("MODEL") },
        { key: "type", label: this.$gettext("TYPE") },
        { key: "odometer", label: this.$gettext("ODOMETER"), tdClass: 'text-right' },
        { key: "used_from", sortable: true, label: this.$gettext("USED FROM"), tdClass: 'text-nowrap' },
        { key: "used_until", sortable: true, label: this.$gettext("USED UNTIL"), tdClass: 'text-nowrap' },
        { key: "archive_clickable", label: ""},
        { key: "edit_clickable", label: ""}
      ],
      tableItems: []
    }
  },
  created() {
    let vm = this;

    CarsService.list({}, window.company_id)
      .then(function(data) {
          vm.tableItems = data;
      });
  },
  methods: {
    rowClicked(item){
      if(item.archived === false){
        this.modalCarData = item;
        this.showCarModal = true
      }else{
          this.$store.commit('setAlert', {
            title: this.$gettext("Not allowed"),
            text: this.$gettext("Cannot edit an archived car"),
            variant: "error",
            duration: 4
          });
      }
    },
    canAddCar() {
      var isPremium = this.$store.getters['getIsPremium'];

      if (this.countUnarchived === 0 || isPremium) {
        this.modalCarData = this.getDefaultCarData();
        this.showCarModal = true
      }
      else
        this.$store.commit('togglePremiumModal', 'web_trips_createcar');
    },
    onCarCreated(value) {
      var item = JSON.parse(JSON.stringify(value));
      this.tableItems.push(item);
    },
    onCarUpdated(value) {
      this.tableKey++;
      for(var i in this.tableItems){
        if(this.tableItems[i].id === value.id){
            this.tableItems[i] = value;
            break;
        }
      }
    },
    getDefaultCarData() {
      return {
          user: window.user_id,
          company_profile: window.company_id,
          plate_number: null
        };
    },
    closeCarsModal () {
      this.showCarModal = false
    }
  },
  computed: {
    countUnarchived(){
      return this.tableItems.filter(element => {
        if (element.archived === false) {
          return true;
        }
        return false;
      }).length
    },
    tableHeaderClass() {
      if (!this.tableItems.length)
        return "table-header-hidden";
      else
        return "table-header-visible";
    }
  }
}
</script>

<style scoped lang="scss">
.edit-button {
  color: $colorBlue; /* info color */
  font-size: 75%;
}

.edit-button:hover {
  color: $colorBlue800;
}

.table-class {
  cursor: pointer;
}
</style>

<style>
table#cars-table .flip-list-move {
  transition: transform 0.3s;
}

.table-header-hidden {
  display: none;
}

.table-header-visible {
  font-size: 12px;
}
</style>